(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gcs-store-search"] && !Shopify.designMode) return;
  try {
    (() => {
  const placeSearch = () => {
    document.querySelectorAll('[data-gcs-store-search]').forEach(bar => {
      const title = bar.closest('main')?.querySelector('h1');
      if (title) title.insertAdjacentElement('afterend', bar);
      bar.dataset.ready = 'true';
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeSearch, { once: true });
  else placeSearch();
  document.addEventListener('shopify:section:load', placeSearch);
})();
  } catch(e) { console.error(e); }
})();

})();
